module.exports = __webpack_public_path__ + "static/media/cohorts-reader-4A.ce9fcaa1.png";